import React from "react";

import classes from "./footer.module.css";

const footer = () => {
  return (
    <div className={classes.footer_bg}>
      <div className={classes.mf}>
        <div className={classes.mains}>
         
            <p className={classes.footer_text}> Copyright &#169; Nikhil Gupta 2021</p>
          

         
        </div>
      </div>
    </div>
  );
};

export default footer;
